import React, { useEffect, useReducer , useState} from 'react';
import { useForm, Controller} from 'react-hook-form';
// import { useHistory, useParams } from 'react-router';
import { splitDateTime } from '../utilities';
import { horseService } from './HorseService.js';
import HorseSelector from './HorseSelector';
import { ImageUpload } from '../common';
import { useNavigate , useParams  } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'



const genderOptions = [
    'Stallion',
    'Mare',
    'Gelding'
]

const breedOptions = [
    'Andalusian',
    'Arabian',
    'Arabian Quarter Horse',
    'Half Arabian',
    'Morgan'
]

const colorOptions = [
    'Bay',
    'Black',
    'Brindle',
    'Buckskin',
    'Champagne',
    'Chestnut',
    'Cream',
    'Cremello',
    'Dun',
    'Grey',
    'Grulla',
    'Leopard',
    'Liver Chestnut',
    'Palomino',
    'Pearl',
    'Perlino',
    'Pinto',
    'Rabicano',
    'White'
]

const initialState = {
    isLoading: true,
    isSubmitting: false,
    isEditting: false,
    horse: undefined,
    uploadImage: undefined
}

const ACTIONS = {
    HORSE_GET_CALL: 'HORSE_GET_CALL',
    HORSE_GET_SUCCESS: 'HORSE_GET_SUCCESS',
    HORSE_GET_ERROR: 'HORSE_GET_ERROR',
    TOGGLE_EDIT: 'TOGGLE_EDIT',
    UPDATE_UPLOAD_IMAGE: 'UPDATE_UPLOAD_IMAGE',
    HORSE_UPDATE_CALL: 'HORSE_UPDATE_CALL',
    HORSE_UPDATE_SUCCESS: 'HORSE_UPDATE_SUCCESS',
    HORSE_UPDATE_ERROR: 'HORSE_UPDATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.HORSE_GET_CALL:
            return {
                ...state, 
                isLoading: true
            }
        case ACTIONS.HORSE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                horse: {
                    ...action.data,
                    foalingDate: action.data.foalingDate ? splitDateTime(action.data.foalingDate)[0] : undefined
                }
            }
        case ACTIONS.TOGGLE_EDIT:
            let isEditting = !state.isEditting
            return {
                ...state,
                isEditting: isEditting,
                uploadImage: isEditting ? state.uploadImage : undefined
            }
        case ACTIONS.UPDATE_UPLOAD_IMAGE:
            return {
                ...state,
                uploadImage: action.data
            }
        case ACTIONS.HORSE_UPDATE_CALL:
            return {
                ...state,
                isSubmitting: true,
                isLoading: false
            }
        case ACTIONS.HORSE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: true
            }
        case ACTIONS.HORSE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                isEditting: false,
                horse: {
                    ...action.data,
                    foalingDate: action.data.foalingDate ? splitDateTime(action.data.foalingDate)[0] : undefined
                }
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}

function HorseEdit() {
    const {contextValue} = useAuth();

    const { horseId } = useParams();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm();
    // const history = useHistory();
    const navigate = useNavigate();
    // const [showRenderImage , setRenderImage] = useState(null)

    useEffect(() => {
            dispatch({ type: ACTIONS.HORSE_GET_CALL });
            horseService.getHorse(horseId)
            .then(response => dispatch({ type: ACTIONS.HORSE_GET_SUCCESS, data: response.data }))
            .catch(error => console.error(error));
    }, [horseId]);

    useEffect(() => {

        if (state.horse || !state.isEditting) {
            console.log(state.horse)

            reset({horse: state.horse});
        }
    }, [state.horse, state.isEditting, reset]);

    function handleEditClick(event) {
        event.preventDefault();
        dispatch({ type: ACTIONS.TOGGLE_EDIT });
    }

    function handleDeleteClick(event) {
        event.preventDefault();
        // if (window.confirm(`This will permanently delete the record for ${state.horse.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action. Press 'Ok' if you are sure you want to delete ${state.horse.name}.`)) {
        //     horseService.deleteHorse(horseId);
        //     window.alert(`${state.horse.name} has been deleted.`);
        //     // history.push('/horse');
        //     navigate('/horse');
        // }



        const message = `This will permanently delete the record for ${state.horse.name}, and any asscoiated records such as scores and ranks. There is no way to undo this action.`

        Swal.fire({
            title: 'Are you sure?',
            text: message,
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {

                contextValue.showLoader();
                contextValue.updateLoaderText("Deleting horse...");

                horseService.deleteHorse(horseId).then(response => {
                    toast.success(`${state.horse.name} has been deleted.`);
                    navigate('/horse');
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Error deleting horse");
                })
                .finally(() => contextValue.hideLoader());

              // delete logic here
            }
          });



    }

    function handleSaveClick({horse}) {

        contextValue.showLoader();
        contextValue.updateLoaderText("Updating horse...");

        dispatch({ type: ACTIONS.HORSE_UPDATE_CALL });

        horseService.updateHorse(horseId, {
            ...horse,
            sireId: horse.sire?.id,
            damId: horse.dam?.id,
            image: state.uploadImage
        })

        .then(response => {
            dispatch({ type: ACTIONS.HORSE_UPDATE_SUCCESS, data: response.data })
            toast.success("Horse updated successfully");
        })
        .catch(error => {
            toast.error("Error updating horse");
            dispatch({ type: ACTIONS.HORSE_UPDATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());



        // .then(response => dispatch({ type: ACTIONS.HORSE_UPDATE_SUCCESS, data: response.data }));
    }

    function handleImageUpload(image) {


        dispatch({ type: ACTIONS.UPDATE_UPLOAD_IMAGE, data: image});
    }

    function renderHorseImage() {
        let src;


        if (state.uploadImage) {
            src = URL.createObjectURL(state.uploadImage);
        } else if (state.horse.imagePath) {
            src = `${process.env.REACT_APP_MEDIA_HOST}/${state.horse.imagePath}`;
        } else {
            src = '/images/horse_image_default.jpg'
        }
        

        return (
            <img className='m-auto mt-2 h-100 w-100 rounded-3' src={src} alt=''/>
        );

    }
    
    function renderGenderOptions() {
        return genderOptions.map((item) => (
            <option key={`gender${item}`} value={item}>{item}</option>
        ));
    }

    function renderBreedOptions() {

        return breedOptions.map((item) => (
            <option key={`breed${item}`} value={item}>{item}</option>
        ));
    }

    function renderColorOptions() {
        return colorOptions.map((item) => (
            <option key={`color${item}`} value={item}>{item}</option>
        ));
    }

    return (
        <div className='container h-100 overflow-auto'>
            {!state.isLoading &&
                <form>
                    <div className='row mb-3'>
                        <h2 className='col'>{state.horse.name}</h2>
                        {!state.isEditting &&
                            <div className='col-auto'>
                                <button className='btn btn-primary me-2' onClick={handleEditClick}>Edit</button>
                                <button className='btn btn-danger text-white' onClick={handleDeleteClick}>Delete</button>
                            </div>
                        }
                        {state.isEditting &&
                            <div className='col-auto'>
                                <button type='submit' className='btn btn-success text-white me-2' onClick={handleSubmit(handleSaveClick)}>Save</button>
                                <button className='btn btn-primary' onClick={handleEditClick}>Cancel</button>
                            </div>
                        }
                    </div>
                    <div className="row align-items-center">
                        <div className='col-sm col-lg-auto mb-3'>
                            <div className='picture-container m-auto'>
                                { renderHorseImage()}
                                {state.isEditting &&
                                    <button type='button' className='btn btn-primary w-100' data-bs-toggle='modal' data-bs-target='#photoUpload'>
                                        Upload Image
                                    </button>
                                }
                                <ImageUpload id='photoUpload' aspectRatio={1} onUpload={handleImageUpload}/>
                            </div>
                        </div>
                        <div className='col-lg'>
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='horseName' className='form-label'>Name:</label>
                                    <input type='text' className='form-control' id='horseName' autoComplete='off' {...register('horse.name', {required: true})} disabled={!state.isEditting}/>
                                    {errors.horse?.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
                                </div>
                                <div className='col'>
                                    <label htmlFor='horseRegistrationNumber' className='form-label'>Registration Number:</label>
                                    <input type='text' className='form-control'  id='horseRegistrationNumber' autoComplete='off' {...register('horse.registrationNumber')} disabled={!state.isEditting}/>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='horseGenderId' className='form-label'>Gender:</label>
                                    <select type='text' className='form-select' id='horseGenderId'
                                    value={state.horse.genderId}
                                    autoComplete='off' {...register('horse.genderId')} disabled={!state.isEditting}>
                                        {renderGenderOptions()}
                                    </select>
                                </div>
                                <div className='col'>
                                    <label htmlFor='horseBreedId' className='form-label'>Breed:</label>
                                    
                                    <select className='form-select'  id='horseBreedId' autoComplete='off'
                                    value={state.horse.breedId}
                                    {...register('horse.breedId')} disabled={!state.isEditting}> 
                                        {renderBreedOptions()}
                                    </select>
                                </div>
                                <div className='col'>
                                    <label htmlFor='horseColorId' className='form-label'>Color:</label>
                                    <select className='form-select' id='horseColorId' 
                                    value={state.horse.colorId}
                                    autoComplete='off' {...register('horse.colorId')} disabled={!state.isEditting}>
                                        {renderColorOptions()}
                                    </select>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='horseBreeder' className='form-label'>Breeder:</label>
                                    <input type='text' className='form-control'  id='horseBreeder' autoComplete='off' {...register('horse.breeder')} disabled={!state.isEditting}/>
                                </div>
                                <div className='col-auto'>
                                    <label htmlFor='horseFoalingDate' className='form-label'>Foaling Date:</label>
                                    <input type={state.isEditting ? 'date' : 'text'} className='form-control'  id='horseFoalingDate' autoComplete='off' {...register('horse.foalingDate')} disabled={!state.isEditting}/>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <div className='col'>
                                    <label htmlFor='horseSire' className='form-label'>Sire</label>
                                    <Controller
                                        control={control}
                                        name='horse.sire'
                                        render={({ field: { onChange, value } }) => (
                                            <HorseSelector className='form-control' id='horseSire' value={value} onChange={onChange} disabled={!state.isEditting}></HorseSelector>
                                        )}
                                    />
                                    {state.isEditting &&
                                        <div className='form-text'>If the sire does not exist in our database, you will have to create it separately.</div>
                                    }
                                </div>
                                <div className='col'>
                                    <label htmlFor='horseDam' className='form-label'>Dam</label>
                                    <Controller
                                        control={control}
                                        name='horse.dam'
                                        render={({ field: { onChange, value } }) => (
                                            <HorseSelector className='form-control' id='horseDam' value={value} onChange={onChange} disabled={!state.isEditting}></HorseSelector>
                                        )}
                                    />
                                    {state.isEditting &&
                                        <div className='form-text'>If the dam does not exist in our database, you will have to create it separately.</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            }
        </div>
    );
}

export default HorseEdit;